<template>

    <div v-if="renderComponent" class="relative">

        <div class="rounded-md border border-blue-200 bg-blue-50 p-4 my-3" v-if="orderInfo">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-sm text-blue-700">
                        U kunt door het verslepen van de de pagina's de volgorde wijzigen. Pagina's zijn ook onder
                        andere pagina's te plaatsen, door bij het verplaatsen de pagina een tikje naar rechts te houden
                        en de muisknop los te laten. Klik op "opslaan" wanneer de volgorde naar wens is.
                    </p>
                </div>
            </div>
        </div>

        <div class="rounded-md border border-green-200 bg-green-50 p-4 my-3" v-if="orderSaved">
            <div class="flex">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                         fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-sm text-green-700">
                        Volgorde is succesvol opgeslagen
                    </p>
                </div>
            </div>
        </div>

        <div class="website::admin-websitePages-index-TreeViewComponent"
             :class="{ 'drag': !!draggableEnabled }">

            <table class="dataTable">

                <thead>

                <tr role="row">

                    <th class="" title="Pagina titel: activeer om kolom aflopend te sorteren">Pagina titel</th>
                    <th class=" statistics" width="130">Statistieken</th>
                    <th class="language" v-for="language in languages" v-if="languages.length > 1">
                        <i :class="'flag-icon flag-icon-' + (language === 'en' ? 'gb' : language)"></i>
                    </th>
                    <th class=" user" width="170">Laatst gewijzigd</th>
                    <th class="" width="140">Gepubliceerd</th>
                    <th class="flex-nowrap" width="130">Acties</th>

                </tr>

                </thead>

            </table>

            <div v-if="localWebsiteMenuPages.length < 1" class="empty-tree px-6 py-4">
                <span>Geen items gevonden</span>
            </div>

            <Tree v-else ref="Tree"
                  :data="localWebsiteMenuPages"
                  :draggable="draggableEnabled"
                  @change="fixTreeBackgroundColors()"
                  @drag="startChildIndicator($event)"
                  @drop="stopChildIndicator()">

                <div slot-scope="{data, store}">
                    <template v-if="!data.isDragPlaceHolder">

                        <b v-if="data._vm.level !== 1">
                            <svg class="w-6 h-6 transform rotate-180 ml-3" fill="none" stroke="currentColor"
                                 viewBox="0 0 24 24"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path>
                            </svg>
                        </b>

                        <span
                            :class="draggableEnabled ? 'select-none' : ''"
                            class="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{
                                data.website_page ? ((data.website_page.title_menu || {})[language] || data.website_page.title_page[language]) : '?'
                            }}</span>

                        <div class="ml-auto"></div>

                        <div class="mr-7 statistics" v-if="data.website_page">
                            <SparkLineComponent
                                :values="data.website_page.extra_statistics"
                                :maxValue="maxStatisticValue"/>
                        </div>

                        <div class="languages" v-if="languages.length > 1">
                            <div class="language" v-for="language in languages">
                                <a v-if="data.website_page"
                                   :href="'/admin/modules/website/website-pages/' + (data.website_page ? data.website_page.id : '') + '/edit?menu=' + filteredWebsiteMenu.id + (isMultilanguage ? '&language=' + language : '')">

                                    <!-- TODO Add (nicer) tooltip explaining this icon + showing the percentage of translated. -->
                                    <i :title="Math.round(data.website_page.extra_translationCoverage[language] * 100) + '% vertaald'"
                                       :class="{
										translated: true,
										fa: true,
										[data.website_page.extra_translationCoverage[language] === 0 ? 'fa-plus disabled' : 'fa-check']: true,
										incomplete: data.website_page.extra_translationCoverage[language] < 1
                                    }"></i>

                                </a>
                            </div>
                        </div>

                        <span class="user mr-8" v-if="data.website_page">

							  <div class="flex">
								  <div class="profile-img">
									  <img class="img-fluid rounded-full" v-if="data.website_page.last_edited_user"
                                           :src="data.website_page.last_edited_user.extra_avatar_url"
                                           alt="User avatar"/>
                                      <img class="img-fluid rounded-full dummy" v-else
                                           src="/vendor/galaxy/canvas/img/blocks/common/placeholder_person.jpg"
                                           alt="User avatar" width="30" height="30"/>
								  </div>

								  <div class="edited">
									  <div class="name" v-if="data.website_page.last_edited_user">{{
                                              data.website_page.last_edited_user.name
                                          }}</div>
									  <div class="name" v-else>Onbekend</div>

									  <div class="date">{{
                                              data.website_page.updated_at || '1970-01-01' | formatDate
                                          }}</div>
								  </div>
							  </div>

                        </span>

                        <div class="publish mr-12">
                            <span v-if="data.website_page"
                                  class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium"
                                  :class="(data.website_page.extra_isPublished ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800')">
                              <svg class="-ml-0.5 mr-1.5 h-2 w-2"
                                   :class="(data.website_page.extra_isPublished ? 'text-green-400' : 'text-red-400')"
                                   fill="currentColor" viewBox="0 0 8 8">
                                <circle cx="4" cy="4" r="3"/>
                              </svg>
                              {{ data.website_page.extra_isPublished ? 'Online' : 'Offline' }}
                            </span>
                        </div>

                        <div class="edit_actions flex">

                            <div class="relative inline-block text-left mr-3 pageAdd" x-data="{ isOpen: false }">

                                <button type="button"
                                        x-on:click="isOpen = !isOpen"
                                        class="bg-indigo-600 hover:bg-indigo-700 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 transition">
                                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" width="13.631"
                                         height="13.631"
                                         viewBox="0 0 13.631 13.631">
                                        <g id="Icon_feather-plus" data-name="Icon feather-plus"
                                           transform="translate(-6.5 -6.5)">
                                            <path id="Path_120" data-name="Path 120" d="M18,7.5V19.131"
                                                  transform="translate(-4.685)" fill="none"
                                                  stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
                                                  stroke-width="2"/>
                                            <path id="Path_121" data-name="Path 121" d="M7.5,18H19.131"
                                                  transform="translate(0 -4.685)" fill="none"
                                                  stroke="#fff" stroke-linecap="round" stroke-linejoin="round"
                                                  stroke-width="2"/>
                                        </g>
                                    </svg>
                                </button>

                                <div x-cloak
                                     x-show="isOpen"
                                     x-on:click.away="isOpen = false"
                                     x-transition:enter="transition ease-out duration-100 transform"
                                     x-transition:enter-start="opacity-0 scale-95"
                                     x-transition:enter-end="opacity-100 scale-100"
                                     x-transition:leave="transition ease-in duration-75 transform"
                                     x-transition:leave-start="opacity-100 scale-100"
                                     x-transition:leave-end="opacity-0 scale-95"
                                     class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 mt-1">

                                    <a :href="'/admin/modules/website/website-pages/create?after=' + (data.website_page ? data.website_page.id : '') + '&menu=' + filteredWebsiteMenu.id + (isMultilanguage ? '&language=' + language : '')"
                                       class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition">
                                        <div class="title">
                                            <i class="fa fa-arrow-down"></i>
                                            Na pagina toevoegen
                                        </div>
                                    </a>

                                    <a :href="'/admin/modules/website/website-pages/create?submenu=' + (data.website_page ? data.website_page.id : '') + '&menu=' + filteredWebsiteMenu.id + (isMultilanguage ? '&language=' + language : '')"
                                       class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition">
                                        <div class="title">
                                            <i class="fas fa-arrow-alt-from-left"></i>
                                            Als subpagina toevoegen
                                        </div>
                                    </a>

                                    <form action="/admin/modules/website/website-pages/duplicate" method="post"
                                          x-data="{ buttonDisabled: false }"
                                          v-if="data.website_page.is_deletable == 1"
                                    >
                                        <input name="page" :value="data.website_page ? data.website_page.id : ''"
                                               hidden>
                                        <button
                                            class="page-dup block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition flex w-full"
                                            type="submit"
                                            x-on:click="buttonDisabled = true"
                                            x-bind:disabled="buttonDisabled">
                                            <div class="title">
                                                <i class="fad fa-clone"></i>
                                                Dupliceren
                                            </div>
                                        </button>
                                    </form>

                                </div>

                            </div>

                            <a :href="'/admin/modules/website/website-pages/' + (data.website_page ? data.website_page.id : '') + '/edit?menu=' + filteredWebsiteMenu.id + (isMultilanguage ? '&language=' + language : '')"
                               class="bg-yellow-500 hover:bg-yellow-600 text-white rounded-full mr-3 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-yellow-500 transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15.919" height="15.919"
                                     viewBox="0 0 15.919 15.919">
                                    <path id="Icon_feather-edit-2" data-name="Icon feather-edit-2"
                                          d="M13.529,3.839a1.985,1.985,0,1,1,2.808,2.808L6.861,16.123,3,17.176l1.053-3.861Z"
                                          transform="translate(-2 -2.257)" fill="none" stroke="#fff"
                                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </svg>
                            </a>

                            <form v-if="data.website_page.is_deletable"
                                  method="post"
                                  :action="'/admin/modules/website/website-pages/'+ (data.website_page ? data.website_page.id : '') + '?menu=' + filteredWebsiteMenu.id + (isMultilanguage ? '&language=' + language : '')">
                                <input name="_method" type="hidden" value="DELETE">
                                <input type="hidden" name="_token" :value="csrfToken">
                                <button
                                    class="bg-red-500 hover:bg-red-600 text-white rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-red-500 transition"
                                    type="submit"
                                    data-confirm="Weet u zeker dat u dit item wilt verwijderen?">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13.393" height="13.389"
                                         viewBox="0 0 13.393 13.389">
                                        <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close"
                                              d="M19.568,17.983,24.352,13.2a1.121,1.121,0,0,0-1.585-1.585L17.983,16.4,13.2,11.615A1.121,1.121,0,1,0,11.615,13.2L16.4,17.983l-4.783,4.783A1.121,1.121,0,1,0,13.2,24.352l4.783-4.783,4.783,4.783a1.121,1.121,0,1,0,1.585-1.585Z"
                                              transform="translate(-11.285 -11.289)" fill="#fff"/>
                                    </svg>
                                </button>
                            </form>

                        </div>

                    </template>

                </div>

            </Tree>

        </div>

    </div>

</template>

<script>

// Note: This deprecated DraggableTree must use draggable-helper@1.0.19 at max!
import {DraggableTree} from 'vue-draggable-nested-tree'
import SparkLineComponent from './SparkLineComponent';

export default {

    components: {
        Tree: DraggableTree,
        SparkLineComponent,
    },

    props: {
        filteredWebsiteMenu: Object,
        websiteMenuPages: Array,
        maxStatisticValue: Number,
        languages: Array,
        language: String
    },

    data() {
        return {
            localWebsiteMenuPages: this.websiteMenuPages,
            draggableEnabled: false,
            csrfToken: null,
            orderInfo: false,
            orderSaved: false,
            renderComponent: true,
            childIndicator: null,
        }
    },

    mounted() {
        // Set csrf token
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        // Hide formActions by default
        this.hideFormActions();

        // Prepare buttons for actions
        this.initSaveOrder();
        this.initSaveButton();
        this.initCancelButton();

        this.initTreeBackgroundColors();
    },

    methods:
        {
            // Set items draggable (and/or save items?)
            initSaveOrder() {
                // Listen for save order button click.
                $('.website\\:\\:admin-websitePages-Index .changeOrder')
                    .on('click', (event) => {
                        if (!$(event.currentTarget).attr("disabled")) {
                            // Set tree to draggable
                            this.draggableEnabled = true;
                            this.orderInfo = true;

                            // Hide saved message
                            this.orderSaved = false;

                            // Set value and toggle class
                            this.disableChangeOrder();
                            this.showFormActions();
                            this.fixTreeBackgroundColors();
                        }
                    });
            },

            initSaveButton() {
                $('.website\\:\\:admin-websitePages-Index .saveButton')
                    .on('click', (event) => {
                        // Disable draggable
                        this.draggableEnabled = false;
                        this.orderInfo = false;

                        // Hide form action buttons
                        this.hideFormActions();

                        // Re-enable changeOrder button
                        this.enableChangeOrder();

                        // Save tree data
                        this.saveData();
                    });
            },

            initCancelButton() {
                $('.website\\:\\:admin-websitePages-Index .cancelButton')
                    .on('click', (event) => {
                        // Set tree to draggable
                        this.draggableEnabled = false;
                        this.orderInfo = false;

                        // Hide saved message
                        this.orderSaved = false;

                        // Hide form action buttons
                        this.hideFormActions();

                        // Reload page to refresh order
                        location.reload();
                    });
            },

            hideFormActions() {
                $('.website\\:\\:admin-websitePages-Index .formActions')
                    .addClass('hidden');
            },

            showFormActions() {
                $('.website\\:\\:admin-websitePages-Index .formActions')
                    .removeClass('hidden');
            },

            enableChangeOrder() {
                $('.website\\:\\:admin-websitePages-Index .changeOrder')
                    .removeClass('cursor-not-allowed disabled')
                    .addClass('cursor-pointer')
                    .attr("disabled", false);
            },

            disableChangeOrder() {
                $('.website\\:\\:admin-websitePages-Index .changeOrder')
                    .addClass('cursor-not-allowed disabled')
                    .removeClass('cursor-pointer')
                    .attr("disabled", true);
            },

            saveData() {
                // Add csrf token
                this.localWebsiteMenuPages._token = this.csrfToken;

                // Save data
                $.post('/admin/modules/website/website-pages/saveOrder', {
                    'website_menu_id': this.filteredWebsiteMenu.id,
                    'children': JSON.stringify(this.$refs['Tree'].getPureData())
                })
                    .done(() => {
                        // Show saved message
                        this.orderSaved = true;

                        // Force rerender to prevent still being able to drag items
                        this.forceRerender();
                    });
            },

            forceRerender() {
                // Remove component from the DOM
                this.renderComponent = false;

                // Execute on next tick
                this.$nextTick(() => {
                    // Add the component back in
                    this.renderComponent = true;
                });

                this.fixTreeBackgroundColors();
            },

            initTreeBackgroundColors() {
                let treeEl = $('.tree-node-inner-back');
                treeEl.last().addClass('rounded-b-xl');
                treeEl.odd().addClass('bg-gray-50');
            },

            fixTreeBackgroundColors() {
                this.$nextTick(() => {
                    $('.tree-node-inner-back').removeClass('bg-gray-50 rounded-b-xl');

                    this.$nextTick(() => {
                        this.initTreeBackgroundColors();
                    });
                });
            },

            startChildIndicator($event) {
                this.childIndicator = setInterval(() => {
                    let placeholder = $('.draggable-placeholder');
                    let nthChild = placeholder.parents('.tree-node').length;
                    let margin = (nthChild - 1) * 30;

                    $('[data-draggable-margin]').remove();
                    $('<style data-draggable-margin>.draggable-placeholder { margin-left: '+margin+'px }</style>').appendTo($('body'));
                }, 500);
            },

            stopChildIndicator() {
                clearInterval(this.childIndicator);
                $('[data-draggable-margin]').remove();
            }
        },

    filters: {
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
        }
    },

    computed:
        {
            Math() {
                return window.Math;
            },

            isMultilanguage() {
                return this.languages.length > 1;
            }
        }

}

</script>

<style lang="scss">
.website\:\:admin-websitePages-index-TreeViewComponent {

    .dataTable {
        @apply min-w-full divide-y divide-gray-200 rounded-t-xl overflow-hidden;
        margin-bottom:       0 !important;
        border-bottom-width: 0;
        border-left-width:   1px;
        border-right-width:  1px;
        border-top-width:    1px;
        border-spacing:      revert;

        th.language {
            width:          45px;
            padding:        0;
            vertical-align: middle;
            text-align:     center;
        }

        th.user {
            padding-left: 30px;
        }

        thead {
            @apply bg-gray-50;

            th {
                @apply px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider;

                &:before {
                    @apply mr-1;
                }
            }
        }
    }

    .tree {
        @apply border rounded-b-xl bg-white;

        .tree-node {

            .draggable-placeholder {
                @apply border-4 border-dashed border-gray-200 rounded-lg;
                height: 71px;
            }
        }
    }

    .empty-tree {
        @apply px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900;
        border: 1px solid #e5e7eb;
    }

    .tree-node {
        .tree-node-children {

            .tree-node {

                // Standard row styling
                .tree-node-inner-back {
                    margin:  0 !important;
                    padding: 7px 15px 7px 0;

                    // Inner row styling
                    .tree-node-inner {
                        padding-left: 15px;

                        > div {
                            position:    relative;
                            display:     flex;
                            align-items: center;
                        }

                        // Statistics styling
                        .statistics {
                            padding-left: 5px;
                            width:        140px;
                        }

                        // Language column styling
                        .languages {
                            display: flex;

                            &:before {
                                content:     '';
                                position:    absolute;
                                top:         -8px;
                                bottom:      -8px;
                                margin-left: -5px;
                            }

                            .language {
                                width: 46px;
                                display: inline-flex;
                                justify-content: center;
                                align-items: center;

                                i {
                                    color: #55ce63;

                                    &.disabled {
                                        color: #999;
                                    }

                                    &.fa-check.incomplete {
                                        color: orange;
                                    }
                                }
                            }
                        }

                        // User column styling
                        .user {
                            width:       170px;
                            margin-left: 24px;

                            &:before {
                                content:     '';
                                position:    absolute;
                                top:         -8px;
                                bottom:      -8px;
                                margin-left: -25px;
                            }

                            > div {
                                width: 100%;
                            }

                            .profile-img {
                                img {
                                    margin-top: 5px;
                                    max-height: 30px;
                                }

                                .dummy {
                                    width:      30px;
                                    height:     30px;
                                    object-fit: cover;
                                }
                            }

                            .edited {
                                flex: 1 0 auto;

                                .name {
                                    font-size:     13px;
                                    font-weight:   bold;
                                    margin:        0 3px 0px 10px;
                                    max-width:     80px;
                                    white-space:   nowrap;
                                    text-overflow: ellipsis;
                                    overflow:      hidden;
                                    line-height:   1.7em;
                                }

                                .date {
                                    font-size:   12px;
                                    font-weight: 400;
                                    margin:      0 3px 0px 10px;
                                    max-width:   80px;
                                    white-space: nowrap;
                                    line-height: 1.4em;
                                }
                            }
                        }

                        // Publish column styling
                        .publish {
                            width:        160px;
                            padding-left: 25px;

                            &:before {
                                content:     '';
                                position:    absolute;
                                top:         -8px;
                                bottom:      -8px;
                                margin-left: -25px;
                            }
                        }

                        // Edit actions column styling
                        .edit_actions {
                            @apply px-3 py-3;
                            width: 150px;

                            &:before {
                                content:     '';
                                position:    absolute;
                                top:         -8px;
                                bottom:      -8px;
                                margin-left: -25px;
                            }

                            > a, button:not(.page-dup) {
                                color:           white;
                                font-size:       14px;
                                height:          30px;
                                padding:         7px;
                                width:           30px;
                                display:         inline-flex;
                                justify-content: center;
                                align-items:     center;
                            }
                        }
                    }
                }
            }
        }
    }

    &.drag .tree-node-inner {
        cursor:     pointer;
        transition: opacity .2s;

        &:hover {
            opacity: .6;
        }
    }

}

.ul-none {
    list-style: none;
    margin:     0;
    padding:    0;
}

// Alert
.alert {
    transition: 0.2s;
}

// Change order
.changeOrder {
    &:after {
        content: 'Wijzig volgorde';
        display: inline;
    }

    &.active {
        background-color: #545b62 !important;
        border-color:     #f1f1f1 !important;

        &:after {
            content: 'Volgorde opslaan';
        }
    }
}
</style>
